import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface AgentEvalSuccessRules {
  passMark: number;
  alertBelow: number;
  criticalDouble: boolean;
  notifyBy: 'Email' | 'Slack' | 'None';
}

export interface SuccessRulesDialogData {
  rules: AgentEvalSuccessRules;
}

@Component({
  selector: 'hour4u-admin-agent-eval-success-rules-dialog',
  templateUrl: './success-rules-dialog.component.html',
  styleUrls: ['./success-rules-dialog.component.scss'],
})
export class AgentEvalSuccessRulesDialogComponent {
  passMark: number;
  alertBelow: number;
  criticalDouble: boolean;
  notifyBy: 'Email' | 'Slack' | 'None';
  notifyOptions: Array<'Email' | 'Slack' | 'None'> = ['Email', 'Slack', 'None'];

  constructor(
    private dialogRef: MatDialogRef<AgentEvalSuccessRulesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuccessRulesDialogData
  ) {
    const rules = (data && data.rules) || {
      passMark: 80,
      alertBelow: 75,
      criticalDouble: true,
      notifyBy: 'Email' as const,
    };
    this.passMark = rules.passMark;
    this.alertBelow = rules.alertBelow;
    this.criticalDouble = rules.criticalDouble;
    this.notifyBy = rules.notifyBy;
  }

  save(): void {
    const passMark = Math.max(0, Math.min(100, Number(this.passMark) || 0));
    const alertBelow = Math.max(0, Math.min(100, Number(this.alertBelow) || 0));
    this.dialogRef.close({
      passMark,
      alertBelow,
      criticalDouble: !!this.criticalDouble,
      notifyBy: this.notifyBy || 'Email',
    } as AgentEvalSuccessRules);
  }

  close(): void {
    this.dialogRef.close();
  }
}
